import styled from 'styled-components';
import { Tooltip } from '@mui/material';

export const SCTooltip = styled(Tooltip)`
    & .MuiTooltip-tooltip {
        background-color: #ffffff !important;
        color: #000000 !important;
        border: 1px solid #ccc !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
        font-size: 0.8125rem !important;
        white-space: pre-line !important;
        padding: 12px 16px !important;
        border-radius: 4px !important;
    }

    & .MuiTooltip-popper .MuiTooltip-tooltip {
        background-color: #ffffff !important;
    }

    & .MuiTooltip-arrow {
        color: #ffffff !important;

        &::before {
            border: 1px solid #ccc !important;
            background-color: #ffffff !important;
        }
    }
`;
